module.exports = __webpack_public_path__ + "img/smart-interview-coach.085de8cd.png";